var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('JsonEditorVue',{style:(_vm.editor_height),attrs:{"mode":"text","onRenderMenu":_vm.onRenderMenu,"readOnly":_vm.readOnly},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }